import { useEffect, useState } from 'react'

interface ToastProps {
  message: string
  isVisible: boolean
  onClose: () => void
  duration?: number
  addClassName?: string
}

export default function Toast({ message, isVisible, onClose, duration = 2000, addClassName }: ToastProps) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (isVisible) {
      setShow(true)
      const timer = setTimeout(() => {
        setShow(false)
        setTimeout(onClose, 300)
      }, duration)
      return () => clearTimeout(timer)
    }
  }, [isVisible, duration, onClose])

  if (!isVisible && !show) return null

  return (
    <div
      className={`fixed bottom-32 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 ${addClassName} ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
      }`}
    >
      <div className='bg-toast max-w-[90vw] text-white px-6 py-3 rounded-2xl shadow-lg flex items-center gap-2 whitespace-nowrap'>
        <span className='text-[11px] font-medium whitespace-nowrap'>{message}</span>
      </div>
    </div>
  )
}
